import { render, staticRenderFns } from "./DiscoverAgendados.vue?vue&type=template&id=6f622f15&scoped=true"
import script from "./DiscoverAgendados.vue?vue&type=script&lang=js"
export * from "./DiscoverAgendados.vue?vue&type=script&lang=js"
import style0 from "./DiscoverAgendados.vue?vue&type=style&index=0&id=6f622f15&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f622f15",
  null
  
)

export default component.exports